import React from "react";
import { Link } from "react-router-dom";

const NotFound=()=>{
    return(
        <>
           <div className="spacing-div"></div>
           <section className="terms-conditions">
            <h1 className="section-title h1-heading">404<br />Page Not Found!</h1>
            <p className="not-found-p"> The page you are looking for is not available or has been moved. Try a different page or go to
                  homepage with the button below.</p>
             <button
      className="primary-btn not-found-btn"
    >
     <Link to='/'>Go to HomePage</Link>
    </button>
            </section>
        </>
    )
}

export default NotFound;